import { observable, action, computed } from "mobx"
import _ from "lodash"
import { getCsrfToken } from "../utils/userUtils"

export default class User {
  @observable availableCreditsCount

  constructor(userObject) {
    const o = userObject
    this.csrfToken = getCsrfToken()
    this.displayName = o.display_name
    this.fullName = o.full_name
    this.slug = o.slug
    this.canModerate = o.can_moderate
    this.availableCreditsCount = o.available_credits_count
  }
}
